// src/components/profile-form.js

import React, { useState, Suspense } from 'react';
import CallApi from './apiPost';

const ProfileForm = () => {
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [sendApi, setSendApi] = useState(false)
  const [formInput, setformInput] = useState('')

  const onSubmitHandler = (event) => {
    event.preventDefault();
    const responseBody = {
      firstName: firstName,
      lastName: lastName,
      email: email
    }
    setSendApi(true)
    setformInput(responseBody)
    console.log(JSON.stringify(responseBody))
  }

  const inputChangeHandler = (setFunction, event) => {
    setFunction(event.target.value)
  }

  if (sendApi) {
    return (
      <div className="max-w-md mx-auto">
        <Suspense fallback={
          <div className="flex items-center justify-center p-8">
            <div className="spinner-icon"></div>
          </div>
        }>
          <CallApi data={formInput}/>
        </Suspense>
      </div>
    )
  }

  return (
    <div className="max-w-md mx-auto">
      <form 
        className="bg-neutral-900 text-white p-6 rounded-xl shadow-lg"
        onSubmit={onSubmitHandler}
      >
        <div className="form-group">
          <label htmlFor="first_name" className="form-label text-neutral-200">
            First Name
          </label>
          <input 
            id="first_name" 
            onChange={(e) => inputChangeHandler(setFirstName, e)} 
            type="text"
            className="form-input bg-neutral-800 border-neutral-700 text-white placeholder:text-neutral-500 focus:border-brand-cyan"
          />
        </div>

        <div className="form-group">
          <label htmlFor="last_name" className="form-label text-neutral-200">
            Last Name
          </label>
          <input 
            id="last_name" 
            onChange={(e) => inputChangeHandler(setLastName, e)} 
            type="text"
            className="form-input bg-neutral-800 border-neutral-700 text-white placeholder:text-neutral-500 focus:border-brand-cyan"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email" className="form-label text-neutral-200">
            Email
          </label>
          <input 
            id="email" 
            onChange={(e) => inputChangeHandler(setEmail, e)} 
            type="email" 
            placeholder="Enter valid email"
            className="form-input bg-neutral-800 border-neutral-700 text-white placeholder:text-neutral-500 focus:border-brand-cyan"
          />
        </div>

        <button type="submit" className="btn-primary w-full mt-2">
          Submit
        </button>
      </form>
    </div>
  )
};

export default ProfileForm;
